import React, { useEffect, useState } from 'react';
import { Checkbox } from '../../controls';
import { isRequesting, isRequestNone, isRequestSuccess } from '../../../utils';
import { useBrokerDealers } from '../../../effects/useBrokerDealers';
import { constants } from '../../../constants';
import { useAgreement } from '../../seller-buyside/useAgreement';
import { RequestPopup } from './RequestPopup';
import { useSettlementAgentRequest } from '../useSettlementAgentRequest';
import { RequestToBidButton } from './RequestToBidButton';
import { useSetOnBoardingTooltipCountRequest } from '../../../effects/useSetOnBoardingTooltipCountRequest';
import { OnBoardingTooltipType } from '../../../types/onboarding-tooltips/OnBoardingTooltipType';
import { usePopupOrder } from '../../../effects/usePopupOrder';
import { user } from '../../../user';

export const RequestDirectBiddingAutoOpener: React.FC = () => {
    const maxWatchCount = constants.introduceDirectBiddingPopupMaxWatchCount;

    const brokerDealerListState = useBrokerDealers();
    const brokerDealerListRequestState = brokerDealerListState.requestState;

    const { agreement, requestState: agreementsRequestStatus } = useAgreement();

    const [visible, setVisible] = useState(false);
    const { setCount } = useSetOnBoardingTooltipCountRequest();

    const { sendRequest, requestStateSendRequest } = useSettlementAgentRequest();

    const [dontAscAgain, setDontAscAgain] = useState(false);

    const directBiddingPopupCount =  user.getOnBoardingTooltipCounters()?.DirectBiddingPopup;
    
    const { canShow, markAsShown } = usePopupOrder('RequestDirectBidding');
    
    useEffect(() => {
        if (visible || !canShow || 
            isRequestNone(brokerDealerListRequestState, agreementsRequestStatus) ||
            isRequesting(brokerDealerListRequestState, agreementsRequestStatus)
        ) return;

        const isPopupClosedManually = localStorage.getItem(constants.requestDirectBiddingPopupLocalStorageKey);

        if (
            isRequestSuccess(brokerDealerListRequestState, agreementsRequestStatus) &&
            !isPopupClosedManually &&
            directBiddingPopupCount < maxWatchCount &&
            !agreement
        ) {
            setVisible(true);
        } else {
            markAsShown?.();
        }
    }, [
        brokerDealerListRequestState,
        agreementsRequestStatus,
        directBiddingPopupCount,
        agreement,
        visible,
        maxWatchCount,
        canShow,
        markAsShown
    ]);

    if (!visible) {
        return null;
    }

    const handleSetCount = () =>
        setCount(
            dontAscAgain ? maxWatchCount : directBiddingPopupCount + 1,
            OnBoardingTooltipType.directBiddingPopup
        );

    const handleClosePopup = () => {
        if (!isRequesting(requestStateSendRequest)) {
            localStorage.setItem('requestDirectBiddingPopupClosedManually', JSON.stringify(true));
            handleSetCount();
            setVisible(false);
            markAsShown?.();
        }
    };

    const handleSend = async (clearingBankId?: number) => {
        await sendRequest(clearingBankId);
        handleSetCount();
        setVisible(false);
    };

    return (
        <RequestPopup
            onClose={handleClosePopup}
            inProgress={isRequesting(requestStateSendRequest)}
            handleSendRequest={handleSend}
            visible={visible}
            renderPopupFooter={(
                <>
                    <Checkbox
                        label="Do not ask me again"
                        checked={dontAscAgain}
                        disabled={isRequesting(requestStateSendRequest)}
                        onChange={() => setDontAscAgain(!dontAscAgain)}
                    />
                    <RequestToBidButton
                        onClick={handleSend}
                        disabled={isRequesting(requestStateSendRequest)}
                    >
                        Request KTX Trading
                    </RequestToBidButton>
                </>
            )}
        />
    )
};
